module.exports = __webpack_public_path__ + "img/card-ABC4FF.6212e554.png";